import React, { useContext } from 'react';
import { AngularContext } from 'react-app';
import useScript from 'shared/hooks/use-script';
import { useSelector } from 'react-redux';
import { AnalyticsTokenProps } from 'redux/schemas/app/analytics';
import { useQrveyInitializer } from 'analytics_dashboard/hooks/use-initialize-qrvey';
import useLoadToken from 'analytics_dashboard/hooks/use-load-token';
import { config } from '../../../config/config.json';
import QrveyComponent from './qrvey-component';
import { AnalyticsContext } from './analytics-dashboard';

const QrveyWrapper = () => {
  const { dashboardType: type, pageIdKey, configKeyName } = useContext(AnalyticsContext);
  const { injectServices } = React.useContext(AngularContext);

  const institutionId = useSelector((state) => state.app.currentInstitutionId);
  const isLoading = useSelector(state => state.app.qrveyConfig.isLoading);

  const [$state] = injectServices(['$state']);
  const { catalogId, scenarioId, programId } = $state.params || null;

  const params: AnalyticsTokenProps = {
    type,
    catalogId,
    institutionId,
    pageIdKey,
    scenarioId,
    programId,
  };

  const data = useLoadToken(params);
  const launcherStatus = useScript(config.qrvey.launcherUrl);

  const isReady: boolean = data && launcherStatus === 'ready';
  const { isError } = useQrveyInitializer(data, isReady, isLoading, configKeyName, pageIdKey, type);

  return (
    <QrveyComponent
      isReady={isReady && !isError}
    />
  );
};

export default QrveyWrapper;
